import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/examtask',
    redirect: { name: 'Home' }
  }, 
  {
    path: '/examtask/:examStudentTaskId',
    name: 'ExamTask',
    component: () => import(/* webpackChunkName: "examtask" */ '../views/Exam/Task.vue')
  },     
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "external" */ '../views/Auth/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "external" */ '../views/Auth/Logout.vue')
  },
  {
    path: '/browser',
    name: 'Browser',
    component: () => import(/* webpackChunkName: "home " */ '../views/Browser.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "home " */ '../views/Help.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
